import { jsx as _jsx } from "react/jsx-runtime";
import { useChartData } from '../../context/ChartContext';
import { useTopicMolecule } from '../../context/TopicMoleculeContext';
import { SVGGroup } from '../../elements/SVGGroup';
import { SVGText } from '../../elements/SVGText';
const fontSize = 12;
const marginTop = 45;
function getDiaIds(range) {
    const { diaIDs = [], signals } = range;
    const ids = diaIDs.slice();
    for (const signal of signals) {
        if (signal?.diaIDs) {
            ids.push(...signal.diaIDs);
        }
    }
    return ids;
}
function useAtoms(range) {
    const topicMolecule = useTopicMolecule();
    const diaIDs = getDiaIds(range);
    const atomsList = [];
    for (const [id, topicMoleculeObject] of Object.entries(topicMolecule)) {
        const atoms = [];
        const diaIDsObject = topicMoleculeObject.getDiaIDsObject();
        for (const id of diaIDs) {
            const existingAtoms = diaIDsObject[id]?.existingAtoms;
            if (existingAtoms?.length > 0) {
                atoms.push(...existingAtoms);
            }
        }
        if (atoms.length > 0) {
            atomsList.push({ id, atoms: [...new Set(atoms.sort((a, b) => a - b))] });
        }
    }
    return atomsList;
}
export function Atoms(props) {
    const { range, x } = props;
    const { view: { molecules }, } = useChartData();
    const atomsList = useAtoms(range).filter((atomsList) => molecules?.[atomsList.id]?.showAtomNumber);
    return (_jsx(SVGGroup, { direction: "column", transform: `translate(${x},${marginTop})`, space: 5, children: atomsList.map((row) => (_jsx(SVGText, { x: 0, fontSize: fontSize, borderRadius: 5, padding: 2, rectProps: { fill: 'white', stroke: 'black', strokeWidth: 0.5 }, children: row.atoms.join(',') }, range.id + row.atoms.join(',')))) }));
}
